import * as _ from 'lodash';
import { FormEvent, useState } from 'react';
import { IMatchHistory } from "@nkr/models/index";
import { TableWrapper, LabelWrapper } from "./styles";
import { FormControl } from 'react-bootstrap';

interface IProps {
    list: IMatchHistory[],
    centerId: number
}

const MatchOffers = (props: IProps) => {
    const [selectedCenter, setSelectedCenter] = useState(0);

    const handleCenterChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        setSelectedCenter(parseInt(e.currentTarget.value));
    };

    const getDateLabel = (item: IMatchHistory) => {
        let hoursRounded = Math.round(item.deadlineRemainingHours);
        let days = hoursRounded / 24;

        if (days > 7) {
            return <LabelWrapper bsStyle='success'>{item.deadlineDateTimeLocal}</LabelWrapper>;
        }

        if (days >= 0 && days <= 7) {
            return <LabelWrapper bsStyle='warning'>{item.deadlineDateTimeLocal}</LabelWrapper>;
        }

        if (days < 0) {
            return <LabelWrapper bsStyle='danger'>{item.deadlineDateTimeLocal}</LabelWrapper>;
        }
    };

    const centerList = _.sortBy(_.uniqBy(props.list.map(x => {
        return {
            id: x.recipientCenterId,
            alias: x.recipientCenter
        };
    }), x => x.id), x => x.alias);

    const filteredList = props.list.filter(x => {
        if (selectedCenter > 0) {
            return x.recipientCenterId == selectedCenter;
        }

        return true;
    });

    return (
        <>
            {props.centerId == 0 && (
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                    <div style={{ marginRight: 5 }}>Filter by Center:</div>
                    <div>
                        <FormControl
                            componentClass='select'
                            value={selectedCenter}
                            onChange={handleCenterChange}
                        >
                            <option value={0}>- no filter -</option>
                            {centerList.map(item =>
                                <option key={'ctr-' + item.id} value={item.id}>{item.alias}</option>
                            )}
                        </FormControl>
                    </div>
                </div>
            )}

            <div style={{ height: props.list.length > 25 ? 600 : null, overflowY: props.list.length > 25 ? 'scroll' : null }}>
                <TableWrapper className="table table-condensed table-striped table-bordered">
                    <thead>
                        <tr>
                            <th rowSpan={2}>Swap</th>
                            <th colSpan={2}>Donor</th>
                            <th colSpan={props.centerId == 0 ? 2 : 1}>Recipient</th>
                            <th rowSpan={2}>Transport Method</th>
                            <th rowSpan={2}>Deadline</th>
                            <th rowSpan={2}>Target Surgery<br />Date</th>
                        </tr>
                        <tr>
                            <th>Center</th>
                            <th>Alias</th>

                            {props.centerId == 0 && (
                                <th>Center</th>
                            )}

                            <th>Alias</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredList.map((item, index) =>
                            <tr key={index}>
                                <td><a href={'/center/' + item.recipientCenterId + '/recipient/evaluate-match/' + item.id} target="_blank">{item.swapNumber}</a></td>
                                <td>{item.donorCenter}</td>
                                <td>{item.donorAlias}</td>
                                {props.centerId == 0 && (
                                    <td>{item.recipientCenter}</td>
                                )}
                                <td>{item.recipientAlias}</td>
                                <td>{item.transportMethod}</td>
                                <td>{getDateLabel(item)}</td>
                                <td>{item.targetSurgeryDate}</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </div>
        </>
    );
}

export default MatchOffers;